import { AxiosResponse } from 'axios';
import queryString from 'query-string';

import { EOrganizedBy, ETripEvent } from 'detailsv2/structure';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';

import { getAccountId } from './auth';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

type SampleItinerary = {
  id: string;
  notes: string;
  systemWide: boolean;
  title: string;
};
type GetSampleItineraryListResponse = {
  data: SampleItinerary[];
  meta: {
    totalCount: 1;
    totalPages: 1;
    currentPage: 1;
    currentCount: 1;
    nextPage: null;
    prevPage: null;
    firstPage: true;
    lastPage: true;
    outOfRange: false;
  };
};

type SampleItinerarySchedule = {
  id: number;
  accommodation: unknown;
  datesRange: {
    start: string | null;
    end: string | null;
  };
  daysRange: {
    start: string | null;
    end: string | null;
  };
  details: {
    contentState: unknown;
    pages: unknown[];
  };
  position: number;
  type: 'activity' | 'overnight' | 'day_room';
};
type SampleItineraryTripEvent = {
  id: number;
  attachedPages: unknown[];
  data: unknown;
  datesRange: {
    start: string;
    end: string;
  };
  daysRange: {
    start: number;
    end: number;
  };
  endDate: string;
  endDay: number;
  icon: string;
  itineraryId: string;
  positions: number[];
  showChangedRoomOrPageTooltip: boolean;
  startDate: string;
  startDay: number;
  type: ETripEvent;
};
export type GetSampleItineraryResponse = {
  data: {
    id: string;
    schedules: SampleItinerarySchedule[];
    tripEvents: SampleItineraryTripEvent[];
    scheduleType: EOrganizedBy;
  };
};

export const getSampleListByItineraryId = async (itineraryId: number, search: string) => {
  const query = queryString.stringify({ q: search, limit: 50 }, { skipNull: true, skipEmptyString: true });

  const response = (await decoratedAxiosGet(
    `/acc/${getAccountId()}/itineraries/${itineraryId}/merge_itineraries?${query}`,
  )) as AxiosResponse<GetSampleItineraryListResponse>;
  return response.data;
};

export const getSampleListBySampleItineraryId = async (sampleitineraryId: number, search: string) => {
  const query = queryString.stringify({ q: search, limit: 50 }, { skipNull: true, skipEmptyString: true });

  const response = (await decoratedAxiosGet(
    `/acc/${getAccountId()}/sample_itineraries/${sampleitineraryId}/merge_itineraries?${query}`,
  )) as AxiosResponse<GetSampleItineraryListResponse>;
  return response.data;
};

export const getSampleByItineraryId = async (itineraryId: number, sampleItineraryId: number) => {
  const response = (await decoratedAxiosGet(
    `/acc/${getAccountId()}/itineraries/${itineraryId}/merge_itineraries/${sampleItineraryId}`,
  )) as AxiosResponse<GetSampleItineraryResponse>;
  return response.data;
};

export const getSampleBySampleItineraryId = async (sampleitineraryId: number, sampleItineraryId: number) => {
  const response = (await decoratedAxiosGet(
    `/acc/${getAccountId()}/sample_itineraries/${sampleitineraryId}/merge_itineraries/${sampleItineraryId}`,
  )) as AxiosResponse<GetSampleItineraryResponse>;
  return response.data;
};
